import React from "react";
import Logoimage from "../assets/VardhamanLogo4.jpg";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaPhoneSquareAlt,
  FaWhatsapp,
} from "react-icons/fa";

import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faEnvelope,
  faMapMarkedAlt,
  faPhoneSquare,
} from "@fortawesome/free-solid-svg-icons";
function Footer() {
  return (
    <div id="contact" className="bg-primary text-white border-t-2">
      <div className="relative grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:gap-8 md:gap-6 gap-4 items-center justify-center px-8 py-10 bg-primary">
        <div className="flex flex-col sm:items-center items-center text-center sm:text-left space-y-4">
          <div className="w-auto overflow-hidden rounded-lg shadow-md">
            <img
              src={Logoimage}
              alt="Lokmanya College Logo "
              className="w-full h-auto"
            />
          </div>
          {/*  */}
          {/* <p className="sm:text-lg text-base font-semibold text-white capitalize">
            Connect With Our Social Media Community
          </p> */}
          {/* <div className="flex items-center sm:gap-2 gap-2 justify-center sm:justify-start flex-wrap">
            <Link
              to={
                "https://www.facebook.com/share/18ZKsu3fZR/"
              }
              target="_blank"
              className="bg-white rounded-full shadow-xl p-2"
            >
              <FaFacebookF
                size={24}
                className="hover:text-secondary text-primary transition-colors duration-200"
              />
            </Link>
            <Link
              to={"https://www.instagram.com/lokmanyacollegeofficial/"}
              target="_blank"
              className="bg-white rounded-full shadow-xl p-2"
            >
              <FaInstagram
                size={24}
                className="hover:text-secondary text-primary transition-colors duration-200"
              />
            </Link>
            <Link
              to={"https://wa.me/+917203061010"}
              target="_blank"
              className="bg-white rounded-full shadow-xl p-2"
            >
              <FaWhatsapp
                size={24}
                className="hover:text-secondary text-primary transition-colors duration-200"
              />
            </Link>
            <Link
              to={"https://www.linkedin.com/company/106963878/admin/?lipi=urn%3Ali%3Apage%3Ad_flagsh"}
              target="_blank"
              className="bg-white rounded-full shadow-xl p-2"
            >
              <FaLinkedin
                size={24}
                className="hover:text-secondary text-primary transition-colors duration-200"
              />
            </Link>
            <Link
              to={"tel:+917203061010"}
              target="_blank"
              className="bg-white rounded-full shadow-xl p-2"
            >
              <FaPhoneSquareAlt
                size={24}
                className="hover:text-secondary text-primary transition-colors duration-200"
              />
            </Link>
            <Link
              to={"mailto:mailto:lokmanyaatpc@gmail.com"}
              target="_blank"
              className="bg-white rounded-full shadow-xl p-2"
            >
              <MdEmail
                size={24}
                className="hover:text-secondary text-primary transition-colors duration-200"
              />
            </Link>

          </div> */}
        </div>

        {/* Contact Details */}
        <div className="flex flex-col items-center space-y-4 text-left sm:mb-0 mb-4">
          <h1 className="font-semibold text-2xl capitalize">Contact</h1>
          <div className="flex flex-col items-start space-y-4">
            <address className="not-italic text-base flex items-start w-full">
              <FontAwesomeIcon icon={faMapMarkedAlt} className="text-xl mr-2" />
              <span>
                Shivranjani Cross Road, Satellite, <br />
                Ahmedabad, Gujarat 380015
              </span>
            </address>
            <p className="text-base flex items-start w-full">
              <Link to={"tel:+917203061010"} target="_blank">
                <FontAwesomeIcon
                  icon={faPhoneSquare}
                  className="text-xl mr-2"
                />
                072030 61010
              </Link>
            </p>

            <p className="text-base">
              <Link
                to={
                  "https://mail.google.com/mail/?view=cm&fs=1&to=lokmanyaptc@gmail.com&su=Admissions%202025-26&body=Hello, I would like to know more about the application process."
                }
                target="_blank"
              >
                <FontAwesomeIcon icon={faEnvelope} className="text-xl mr-2" />
                lokmanyaptc@gmail.com
              </Link>
            </p>
            <p className="text-base">
              <Link
                to={
                  "https://mail.google.com/mail/?view=cm&fs=1&to=Hr.lokmanyacollege@gmail.com&su=Apply%20For%20Jobs%20&body=Hello, I would like to ​​apply for a job at Lokmanya College."
                }
                target="_blank"
              >
                <FontAwesomeIcon icon={faBriefcase} className="text-xl mr-2" />
                <span className=" cursor-pointer">
                  hr.lokmanyacollege@gmail.com
                </span>
              </Link>
            </p>
          </div>
        </div>
        {/* Google Map */}
        <div className="flex flex-col items-center space-y-4">
          <h1 className="font-semibold text-2xl capitalize">Locate Us</h1>
          <div className="lg:w-72 lg:h-44 md:w-64 md:h-36 rounded-lg overflow-hidden shadow-md">
            <iframe
              title="Location on Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14688.433247997455!2d72.529433!3d23.019795!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84d05558fc2f%3A0x537ba377311844e7!2sShivranjani%20Cross%20Rd%2C%20Jodhpur%20Village%2C%20Ahmedabad%2C%20Gujarat%20380015!5e0!3m2!1sen!2sin!4v1734417827017!5m2!1sen!2sin"
              className="w-full h-full border-0"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-white text-primary">
        <p className="p-2 px-10">
          @  All Rights Reserved {new Date().getFullYear()} .
        </p>
      </div>
    </div>
  );
}

export default Footer;
